import { jsx as _jsx } from "react/jsx-runtime";
export const IconV2Layer = ({ children }) => {
    return _jsx("span", { className: "fa-layers fa-fw", children: children });
};
